import React from 'react';
import './Main.scss';
import CaseCard from '../../components/CaseCard/CaseCard';
import ProgressBar from '../../components/ProgressBar/ProgressBar';
import {
  ainurposCaseData,
  appplierCaseData,
  ParadoxCaseData,
  CynomiCaseData,
  ReislyCaseData,
  impersonationCaseData,
} from '../../constants/caseCardData';
import { useLocation } from 'react-router-dom';
import FadeInSection from '../../components/FadeInSection';

const Main = () => {
  const { hash } = useLocation();

  React.useEffect(() => {
    if (hash) {
      const element = document.getElementById(hash.replace('#', ''));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [hash]);

  return (
    <section className="main">
      <ProgressBar />
      <div className="main__about">
        <FadeInSection>
          <div className="main__about-text-conainer">
            <div>
              <p>Hey, I’m Cristina Gromov</p>
              <p>
                Product Designer focusing on <span>user-centered design</span> and{' '}
                <span> product growth.</span> Proficient in complex systems.
              </p>
            </div>
            <p>Currently working at Cynomi in Israel, building cybersecurity products</p>
          </div>
          <button className="main__about-email">krsgromov@gmail.com</button>{' '}
        </FadeInSection>
      </div>
      <div className="main__case-card__container" id="cases">
        <FadeInSection>
          <CaseCard {...CynomiCaseData} />
        </FadeInSection>
        <FadeInSection>
          <CaseCard {...ParadoxCaseData} />
        </FadeInSection>
        <FadeInSection>
          <CaseCard {...ainurposCaseData} />
        </FadeInSection>
        <FadeInSection>
          <CaseCard {...ReislyCaseData} />
        </FadeInSection>
        <FadeInSection>
          <CaseCard {...impersonationCaseData} />
        </FadeInSection>
        <FadeInSection>
          <CaseCard {...appplierCaseData} />
        </FadeInSection>
        {/* <CaseCard {...playgroundCaseData} /> */}
      </div>
    </section>
  );
};

export default Main;
